// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0f735213","703":"0202a224","787":"836b549a"}[chunkId] + ".chunk.js";
};